// Professional File Upload Component
import React, { useState, useRef } from 'react';
import '../../css/styles/profileupload.css'
const ProfessionalFileUpload = ({
                                    obj,
                                    onFileChange,
                                    id = 'fileUpload',
                                    name = 'fileUpload',
                                    multiple = false,
                                    maxSize = 100, // MB
                                    className = ''
                                }) => {
    const [dragActive, setDragActive] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const fileInputRef = useRef(null);

    const accept = obj.isimage === 1 ? "image/*" : "*";
    const isImageOnly = obj.isimage === 1;

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFiles(e.dataTransfer.files);
        }
    };

    const handleFiles = (files) => {
        const fileArray = Array.from(files);
        const validFiles = fileArray.filter(file => {
            if (isImageOnly && !file.type.startsWith('image/')) {
                alert('Chỉ chấp nhận file hình ảnh!');
                return false;
            }
            if (file.size > maxSize * 1024 * 1024) {
                alert(`File quá lớn! Tối đa ${maxSize}MB`);
                return false;
            }
            return true;
        });

        setSelectedFiles(validFiles);
        onFileChange({ target: { files: validFiles } });
    };

    const handleFileChange = (e) => {
        if (e.target.files) {
            handleFiles(e.target.files);
        }
    };

    const removeFile = (index) => {
        const newFiles = selectedFiles.filter((_, i) => i !== index);
        setSelectedFiles(newFiles);
        onFileChange({ target: { files: newFiles } });
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const getFileIcon = (file) => {
        if (file.type.startsWith('image/')) return 'fas fa-image';
        if (file.type.includes('pdf')) return 'fas fa-file-pdf';
        if (file.type.includes('word')) return 'fas fa-file-word';
        if (file.type.includes('excel') || file.type.includes('spreadsheet')) return 'fas fa-file-excel';
        return 'fas fa-file';
    };

    return (
        <div className={`professional-file-upload ${className}`}>
            <div
                className={`upload-area ${dragActive ? 'drag-active' : ''}`}
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
                onClick={() => fileInputRef.current?.click()}
            >
                <div className="upload-content">
                    <i className={`upload-icon ${isImageOnly ? 'fas fa-image' : 'fas fa-cloud-upload-alt'}`}></i>
                    <div className="upload-text">
                        <p className="upload-title">
                            {isImageOnly ? 'Tải lên hình ảnh' : 'Tải lên file'}
                        </p>
                        <p className="upload-subtitle">
                            Kéo thả file vào đây hoặc <span className="click-text">nhấp để chọn</span>
                        </p>
                        <p className="upload-info">
                            {isImageOnly ? 'Chấp nhận: JPG, PNG, GIF' : 'Chấp nhận tất cả định dạng'}
                            • Tối đa {maxSize}MB
                        </p>
                    </div>
                </div>
            </div>

            <input
                ref={fileInputRef}
                id={id}
                name={name}
                type="file"
                accept={accept}
                multiple={multiple}
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />

            {selectedFiles.length > 0 && (
                <div className="selected-files">
                    <h6 className="files-title">File đã chọn:</h6>
                    {selectedFiles.map((file, index) => (
                        <div key={index} className="file-item">
                            <div className="file-info">
                                <i className={`file-icon ${getFileIcon(file)}`}></i>
                                <div className="file-details">
                                    <span className="file-name">{file.name}</span>
                                    <span className="file-size">{formatFileSize(file.size)}</span>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="remove-file"
                                onClick={() => removeFile(index)}
                                title="Xóa file"
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProfessionalFileUpload;